module.exports = __webpack_public_path__ + "static/media/credit-card-machine.0f185de5.svg";